import { render } from "./GSSundayC.vue?vue&type=template&id=8b807ade&scoped=true"
import script from "./GSSundayC.vue?vue&type=script&scoped=true&lang=js"
export * from "./GSSundayC.vue?vue&type=script&scoped=true&lang=js"

import "./GSSundayC.vue?vue&type=style&index=0&id=8b807ade&scoped=true&lang=css"

import exportComponent from "C:\\Users\\jgurl\\KontraWebsite\\KontraSports\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8b807ade"]])

export default __exports__